export default __webpack_public_path__ + "static/media/avixenalogo.f1d9b524.svg";